// Envelope format for entries written through the storage service.
//
// Every managed value is wrapped as:
//   { __wp: 1, expiresAt: <epochMs | null>, writtenAt: <epochMs>, value: <data> }
//
//   __wp       marker    — identifies an entry as ours so the TTL sweep never touches foreign keys
//   expiresAt  epoch ms  — moment after which the entry is dead; null = never expires
//   writtenAt  epoch ms  — moment the entry was written; used for LRU-style capping by recency
//   value                — the actual stored value
//
// Reads stay backward compatible: a value without the marker is treated as a plain
// (legacy) value and returned as-is, so adopting the service does not require a data wipe.

export const TTL_MARKER = '__wp';

export function wrap(value, ttlMs = 0) {
  const now = Date.now();
  return {
    [TTL_MARKER]: 1,
    expiresAt: ttlMs > 0 ? now + ttlMs : null,
    writtenAt: now,
    value,
  };
}

export function isEnvelope(obj) {
  return !!obj && typeof obj === 'object' && obj[TTL_MARKER] === 1 && 'value' in obj;
}

export function isExpired(envelope, now = Date.now()) {
  return isEnvelope(envelope) && envelope.expiresAt != null && now >= envelope.expiresAt;
}
